<template>
	<div class='tax-data'>
		<!-- <hr> -->

		<div class='section'>
			<span class='title'>Таксационное описание</span>
			<TaxDataTable/>
		</div>

		<!-- <hr> -->

		<div class='section'>
			<span class='title'>Введение таксационного описания по материалам действующего лесоустройства</span>
			<TaxDataEdit/>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import TaxDataTable from './TaxDataTable';
	import TaxDataEdit from './TaxDataEdit';

	export default {
		name: 'TaxData',
		components: {
			TaxDataTable,
			TaxDataEdit
		},
		computed: {
			...mapState('taxInfo', {
				selectedTax: state => state['selectedTax']
			})
		}
	};
</script>

<style scoped>
	.section {
		margin: 30px 0 70px 0;
	}

	.title {
		display: inline-block;
		font-size: 1.2rem;
		font-weight: bold;
		margin-bottom: 10px;
	}
</style>